module.exports = __webpack_public_path__ + "static/media/new2.6c4b24b0.png";